import React from 'react';
export const Footer = () => {
  return <footer className="bg-brand-teal-dark text-brand-cream/60 py-12 px-4 text-sm text-center" data-id="element-51">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-52">
        <p className="font-medium text-brand-cream/80" data-id="element-53">
          © 2026 KIT Psicología en TCA. Todos los derechos reservados.
        </p>

        <p className="leading-relaxed text-xs" data-id="element-54">
          Este material es una herramienta educativa y profesional para
          psicólogos y terapeutas. No reemplaza formación específica.
        </p>

        <p className="leading-relaxed text-xs" data-id="element-55">
          Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
          este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </div>
    </footer>;
};